
import { createTranslations } from '../i18n/types';

export default createTranslations({
  en: {
    errorOccurred: 'An error occurred',
    retry: 'Try again',
  },
  ru: {
    errorOccurred: 'Произошла ошибка',
    retry: 'Повторить',
  },
  uz: {
    errorOccurred: 'Xatolik yuz berdi',
    retry: 'Qayta urinish',
  },
});
